import { FormikProps } from "formik";
import { useContext } from "react";
import { SubmitBandViewModel } from "../../../../generated/data-contracts";
import { FormikUtils } from "../../../../utils";
import { isTabletOrMobileView } from "../../../shared/appStates/appStates";
import { AvisSaveButton } from "../../../shared/components/buttons";
import { AvisInputText } from "../../../shared/components/inputs";
import { AvisContext } from "../../../shared/context/AvisContext";

interface ISubmitBandFormProps {
  bag: FormikProps<SubmitBandViewModel>;
  loading: boolean;
  showModal: () => void;
}

export function SubmitBandForm(props: Readonly<ISubmitBandFormProps>) {
  const { bag, loading, showModal } = props;
  const { res } = useContext(AvisContext);

  const onSubmitPrompt = async () => {
    const errors = await bag.validateForm();
    if (Object.keys(errors).length > 0) return;

    showModal();
  };

  const renderButton = (
    <AvisSaveButton
      className="m-0"
      onClick={onSubmitPrompt}
      disabled={loading}
    />
  );

  return (
    <div>
      <div className="avis-form-short">
        <AvisInputText<SubmitBandViewModel>
          label={res("authors_BandName_GroupNameLabel")}
          placeholder={res("authors_BandName_GroupNamePlaceholder")}
          bag={bag}
          bagField="name"
          disabled={loading}
          minLength={2}
          maxLength={100}
          spacing="medium"
          onKeyDown={(e) => FormikUtils.handleEnterKeyPress(e, onSubmitPrompt)}
          sideRightIcons={
            isTabletOrMobileView.value ? undefined : [renderButton]
          }
          required
          reserveErrorMessageSpace={true}
        />
      </div>
      {isTabletOrMobileView.value && renderButton}
    </div>
  );
}
